import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import { FormAdapter, FormAlert, FormContainerOptions, FormControlProperties, FormControlType, FormValues } from '@omegagrid/form';
import rp from '@reporting/rp-app-host';
import { Accounting } from "@reporting/rp-types/core";
import { StatementDefinition } from '@reporting/rp-types/definition';
import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";

class AccountingTreeAdapter extends TreeAdapter {

	private items: NodeSource[];
	public accounting: number;

	constructor(
		private options?: Partial<TreeOptions>
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
		this.items = [];
		const accountings = await rp.ms('accounting').get<Accounting[]>('accountings');
		this.items = accountings.map(a => ({
			k: a.accounting.toString(), 
			v: `${a.group_name} / ${a.accounting} ${a.company}`
		}));
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || { selectMode: 'single', autoClose: true, search: true };
	}

}

export class FinReportCopyFormAdapter extends FormAdapter {

	constructor(
		private statement: StatementDefinition
	) { super() }

	getColumns() {
		return [
			{width: 120},
			{width: null},
		];
	}

	async getControls() {
		const yearsFrom = await rp.ms('analytics').get<number[]>(`statementYears/${this.statement.id_statement}/nonempty`);
		const yearsTo = await rp.ms('analytics').get<number[]>(`statementYears/${this.statement.id_statement}/empty`);
		const thisYear = new Date().getFullYear();	
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('From year'), for: 'yearFrom'},
			{row: 0, col: 1, type: FormControlType.List, key: 'yearFrom', required: true, value: thisYear, content: {
				sourceData: yearsFrom.map(year => ({ k: year, v: year })),
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('To year'), for: 'yearTo'},
			{row: 1, col: 1, type: FormControlType.List, key: 'yearTo', required: true, value: thisYear, content: {
				sourceData: yearsTo.map(year => ({ k: year, v: year })),
				options: {selectMode: 'single', autoClose: true}
			}},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Target company'), for: 'accountingTo'},
			{row: 2, col: 1, type: FormControlType.List, key: 'accountingTo', required: true, adapter: new AccountingTreeAdapter(), value: this.statement.accounting.toString() },
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Report name'), for: 'statementTo'},
			{row: 3, col: 1, type: FormControlType.TextInput, key: 'statementTo', required: true },
			
		] as FormControlProperties[];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: [{ key: "save", text: msg("Copy"), color: ColorTypes.Yellow }, "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		await rp.ms('definition').post('statements/copy', {
			idStatement: this.statement.id_statement,
			yearFrom: formValues.yearFrom as number,
			yearTo: formValues.yearTo as number,
			accountingTo: parseInt(formValues.accountingTo as string),
			statementTo: formValues.statementTo as string
		});
		return true;
	}

};
